var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table-custom',_vm._g(_vm._b({attrs:{"headers":_vm.headers,"item-key":"id","permissions-by-module":"users"}},'v-data-table-custom',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }